import { Navigate, Route, Routes } from "react-router-dom";

import { Footer } from "./components/Footer";
import { Navbar } from "./components/Navbar";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { TooltipProvider } from "./components/ui/tooltip";
import { AdminDashboardPage } from "./pages/AdminDashboardPage";
import { AuthPage } from "./pages/AuthPage";
import { CandidateDashboardPage } from "./pages/CandidateDashboardPage";
import { CandidatePortalPage } from "./pages/CandidatePortalPage";
import { LandingPage } from "./pages/LandingPage";
import { OtpVerificationPage } from "./pages/OtpVerificationPage";
import { ProfilePage } from "./pages/ProfilePage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { AdminWorkspaceLayout } from "./pages/admin/AdminWorkspaceLayout";
import {
  AdminAllFormsPage,
  AdminCandidateAgreementsPage,
  AdminCreateFormPage,
  AdminEditFormPage,
  AdminPendingAgreementsPage,
  AdminUsersPage,
  AdminVerifiedApprovalsPage
} from "./pages/admin/AdminRoutePages";

function App() {
  return (
    <TooltipProvider delayDuration={120}>
      <div className="min-h-screen bg-app text-ink">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/apply" element={<Navigate replace to="/auth?role=candidate" />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/otp" element={<OtpVerificationPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route
              path="/candidate"
              element={
                <ProtectedRoute allow="candidate">
                  <CandidateDashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/candidate/internship"
              element={
                <ProtectedRoute allow="candidate">
                  <CandidatePortalPage templateSlug="internship-agreement-india" />
                </ProtectedRoute>
              }
            />
            <Route
              path="/candidate/addendum"
              element={
                <ProtectedRoute allow="candidate">
                  <CandidatePortalPage templateSlug="addendum-offer-letter-india" />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute allow="admin">
                  <AdminWorkspaceLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboardPage />} />
              <Route path="users" element={<AdminUsersPage />} />
              <Route path="pending-users" element={<Navigate replace to="/admin/users?view=pending" />} />
              <Route path="verified-approvals" element={<AdminVerifiedApprovalsPage />} />
              <Route path="all-forms" element={<AdminAllFormsPage />} />
              <Route path="saved-drafts" element={<AdminAllFormsPage initialFilter="draft" />} />
              <Route path="pending-agreements" element={<AdminPendingAgreementsPage />} />
              <Route path="candidate-agreements" element={<AdminCandidateAgreementsPage />} />
              <Route path="create-form" element={<AdminCreateFormPage />} />
              <Route path="edit-form" element={<AdminEditFormPage />} />
            </Route>
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate replace to="/" />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </TooltipProvider>
  );
}

export default App;
